import React from 'react'

export const CreditCard = ({ color, size }) => (
  <svg width={size} height={size} viewBox='0 0 18 13.219'>
    <path
      fill={color}
      d='M14.484,8.161a.7.7,0,0,1,.7.7v.844a.7.7,0,0,1-.7.7H12.867a.7.7,0,0,1-.7-.7V8.864a.7.7,0,0,1,.7-.7Zm2.109,2.25V4.786H1.406v5.621a1.408,1.408,0,0,0,1.406,1.406H15.188a1.408,1.408,0,0,0,1.406-1.406c0-.388,1.406-.388,1.406,0a2.816,2.816,0,0,1-2.812,2.812H2.812A2.816,2.816,0,0,1,0,10.406V2.812A2.816,2.816,0,0,1,2.812,0H15.188A2.816,2.816,0,0,1,18,2.812v7.6C18,10.8,16.594,10.8,16.594,10.411Zm0-7.031V2.812a1.408,1.408,0,0,0-1.406-1.406H2.812A1.408,1.408,0,0,0,1.406,2.812v.567ZM3.516,6.192a.7.7,0,1,0,0,1.406h5.8a.7.7,0,1,0,0-1.406Zm0,0'
    />
  </svg>
)

CreditCard.defaultProps = {
  color: '#4e5657',
  size: 18
}
